import { Timer } from '../../domain/timer';

export class ClientTimer implements Timer {
  setInterval(fn: () => void, ms: number): number {
    return window.setInterval(fn, ms);
  }
}
